<nav class="navbar navbar-default blue-bg">
    <div class="container container-fluid">
        <div class="navbar-header">
            <h1 class="navbar-brand">Strona logowania</h1>
        </div>
    </div>
</nav>

<div class="w-11 mlrauto flex-1">
    <p-messages [value]="message" [enableService]="false" [closable]="false" showTransitionOptions="0s" hideTransitionOptions="0s" styleClass="margin-top-bottom-10"/>
    <div class="grid justify-content-space-center">
        <div class="w-full md:wp-4 flex align-items-center justify-content-center flex-direction-column">
            <div class="text-align-center margin-top-bottom-10">
                Zanim się zalogujesz po raz pierwszy, przygotuj komplet <strong>aktualnych dokumentów</strong>
            </div>
            <a pButton icon="pi pi-external-link" href="https://knf.gov.pl/dla_rynku/posrednictwo_finansowe/rynek_posrednikow_kredytowych" target="_blank" class="unlink">&nbsp;Sprawdź szczegóły</a>
        </div>
        <div class="w-full md:wp-1 hidden md:visible">
            <p-divider layout="vertical">
            </p-divider>
        </div>
        <div class="w-full md:wp-2 visible md:hidden">
            <p-divider align="center" layout="horizontal">
            </p-divider>
        </div>
        <div class="w-full md:wp-4 flex align-items-center justify-content-center flex-direction-column margin-top-bottom-10">
            <img src="assets/images/logo_login.svg" alt="logo profilu zaufanego" width="200px"/>
            <div class="wrapper">
            <!--
                <button *ngIf="!authService.isAuthenticated()" pButton
                        icon="pi pi-exclamation-triangle"
                        label="Fake login(test)" (click)="fakeLogin()"
                        class="align-right p-button-danger"></button>
                &nbsp;
            -->
                <p-button label="Zaloguj" icon="pi pi-sign-in" [loading]="loading" (click)="login()"></p-button>
            </div>
        </div>
    </div>
</div>

<div class="w-11 mlrauto">
    <div class="w-full">
        <p-divider align="center" layout="horizontal">
        </p-divider>
    </div>
    <div class="w-full smallfont text-align-center">
        <rodo></rodo>
    </div>
</div>

<form ngNoForm method="POST" action="{{SSO_URL}}">
    <input type="hidden" name="SAMLRequest" value=""/>
    <input type="hidden" name="ForeignAuthentication" value="true"/>
    <noscript><p>JavaScript jest wyłączony. Rekomendujemy włączenie. Aby kontynuować, proszę
        nacisnąć przycisk poniżej.</p>
        <button type="submit">Zaloguj</button>
    </noscript>
</form>

